import { createModuleQueries } from "src/framework/createModuleQueries.ts";
import { useMemo } from "react";

export const useResourceQueries = () => {
  return useMemo(() => createModuleQueries(), []);
};
